import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { getValueWithMapLinks, prepareTableData, transformResponse } from "../../../features/dataFormatFunctions/dataFormatter";
import { tableBooleanEnums, tableEnums } from "../../table/tableFeatures/tableEnums";
import { store } from "../../../stateManagement/store";
import { Loader } from "../../loaders/Loader";
import { getItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";
import { getMeasureResultsTableBasicBody, getBooleanBody } from "../../tablesShared/tableTools/tableCellBodies";
import { prepareQueryArgsForTableFetch } from "../../tablesShared/tableTools/fetchTableValue";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { useDispatch } from "react-redux";
import { setTableDataCount } from "../../../stateManagement/reducers";
import { getDataArrayWithMaintenanceEnding, getDataArrayWithMaintenancePosition } from "../../../features/dataFormatFunctions/formatMaintenancePoint";

const possibleEventTypes = ['Диагностика', 'Мониторинг', 'Диагностика (плановая)']
// Осмотр мостов, ...

const fieldsNoToWrap = ['Position', 'SectionStart', 'MaintenancePosition', 'MaintenancePositionDescription', 'Ending', 'SectionEnd', 'MaintenanceEnding']

function getDiagnosticsSegmentsWithDefiniteType(value: any) {
    const newValue: any = []
    value.map((item: any) => {
        if (possibleEventTypes.filter((type: any) => item.EventTypeString === type)[0]) {
            newValue.push(item)
        }
    })
    return newValue
}

// Компонент - кнопка действия в шапке для контент-поля.
export function DiagnosticsMeasureResultsTable({ columns, filters, objectType, valueLength, way, pathId, headerGroup, type,
    measureId, defectClassificator, dateFilters, actualMeasureResultsMark, expandList, period }: any) {

    const dispatch = useDispatch()

    const [loading, setLoading] = useState(true);
    const [tableValue, setTableValue] = useState<any>([]);

    const dataCount = useAppSelector(state => state.table.dataCount)

    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app

    function getLocalLazyStateValue() {
        let lazyStateStartLocalValue = {
            first: 0,
            rows: 100,
            page: 0,
            sortField: null,
            sortOrder: null,
            filters: filters
        }
        return lazyStateStartLocalValue
    }

    const [lazyState, setLazyState] = useState<any>(() => getLocalLazyStateValue());

    useEffect(() => {
        if ((objectType || type) && way) {
            setLazyState({
                first: 0,
                rows: 100,
                page: 0,
                sortField: null,
                sortOrder: null,
                filters: filters
            })
        }
    }, [objectType, type, measureId, way, period])

    useEffect(() => {
        if (objectType && way) {
            loadLazyData();
        }
    }, [lazyState.page, lazyState.filters]);

    function loadLazyData() {
        setLoading(true);
        fetchTableData()
    }

    async function fetchTableData() {
        try {
            let { sortQueryArgsParameters, filterStringArray, page }: any = prepareQueryArgsForTableFetch(lazyState, columns)
            if (measureId && !way.includes('Defect') && !actualMeasureResultsMark) {
                filterStringArray.push(`MeasureId eq ${measureId}`)
            }
            // if (defectClassificator && way.includes('Defect')) {
            //     filterStringArray.push(`DefectClassificator eq ${defectClassificator}`)
            // }
            if ((measureId || defectClassificator) && !actualMeasureResultsMark) {
                let response = null
                if (measureId && !way.includes('Defect')) {
                    response = await fetch(`${currentApiUrl}/${way}?$skip=${page * 100}&$inlinecount=allpages&$orderby=Position`
                        + `&$top=${100}&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') : `${null} eq ${null}`})`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                }
                if (defectClassificator && way.includes('Defect')) {
                    filterStringArray = filterStringArray.concat(dateFilters)
                    response = await fetch(`${currentApiUrl}/diagnostics/DefectSegments/?$skip=${page * 100}&$inlinecount=allpages&$orderby=Position`
                        + `&$top=${100}&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') : `${null} eq ${null}`} ${pathId === 'all' ? '' : `and pathId eq ${pathId}`})`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                }
                if (!response?.ok) {
                    throw new Error('Failed to fetch');
                }
                const data = await response.json()
                dispatch(setTableDataCount(data[`@xdata.count`]))
                let value = transformResponse(data).value
                // добавление поля ссылка на карту для каждого объекта
                value = getValueWithMapLinks(value, objectType)
                value = prepareTableData(value, columns)
                if (objectType === 'RoadDiagnosticsSegments') {
                    value = getDiagnosticsSegmentsWithDefiniteType(value)
                }
                if (objectType === 'RoadMeasures' || type === 'RoadDefects' || type === 'RoadMeasureResults') {
                    value = getDataArrayWithMaintenancePosition(value)
                    value = getDataArrayWithMaintenanceEnding(value)
                }
                value && setTableValue(value)
                setLoading(false)
            }
            if (actualMeasureResultsMark) {
                let response = null
                if (!way.includes('Defect')) {
                    filterStringArray = filterStringArray.concat(dateFilters)
                    response = await fetch(`${currentApiUrl}/${way}?$skip=${page * 100}&$inlinecount=allpages&$orderby=Position`
                        + `&$top=${100}&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') + ' and ' : ``}pathId eq ${pathId})`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                }
                if (way.includes('Defect')) {
                    filterStringArray = filterStringArray.concat(dateFilters)
                    response = await fetch(`${currentApiUrl}/${way}?$skip=${page * 100}&$inlinecount=allpages&$orderby=Position`
                        + `&$top=${100}&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') + ' and ' : ``}pathId eq ${pathId})`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                }
                if (!response?.ok) {
                    throw new Error('Failed to fetch');
                }
                const data = await response.json()
                dispatch(setTableDataCount(data[`@xdata.count`]))
                let value = transformResponse(data).value

                // добавление поля ссылка на карту для каждого объекта
                value = getValueWithMapLinks(value, objectType)
                value = prepareTableData(value, columns)
                if (objectType === 'RoadDiagnosticsSegments') {
                    value = getDiagnosticsSegmentsWithDefiniteType(value)
                }
                if (objectType === 'RoadMeasures' || type === 'RoadDefects' || type === 'RoadMeasureResults') {
                    value = getDataArrayWithMaintenancePosition(value)
                    value = getDataArrayWithMaintenanceEnding(value)
                }
                value && setTableValue(value)
                setLoading(false)
            }
            if (!defectClassificator && !measureId && !actualMeasureResultsMark) {
                dispatch(setTableDataCount(0))
                setTableValue([])
                setLoading(false)
            }
        } catch (error) {
            // Выводим сообщение об ошибке в консоль
            console.error('Fetch error:', error);
            setLoading(false)
        }
    }
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const [hiddenContentHeader, setHiddenContentHeader] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setHiddenContentHeader(contentHeaderWidth < 1080);
    }, [sideBarState, navigate])

    // Шаблон отображения варианта выбора в выпадающем списке
    function getItemTemplate(option: any) {
        return <span>{option}</span>;
    }

    // Шаблон фильтра с вариантами выбора
    function getOptionsRowFilterTemplate(
        options: { value: any; filterApplyCallback: (value: any) => void },
        placeholder: string | undefined,
        variants: any[] | undefined
    ) {
        const { value, filterApplyCallback } = options;
        return (
            <Dropdown value={options.value} options={variants} onChange={(e) => filterApplyCallback(e.value)}
                itemTemplate={getItemTemplate} placeholder={placeholder} className="p-column-filter"
                showClear style={{ minWidth: '12rem' }} />
        );
    }

    function onPage(event: any) {
        let table: any = document.querySelector('.p-datatable-wrapper');
        table.scrollTo({ top: 0 });
        setLazyState(event);
    }

    function onSort(event: any) {
        event['page'] = 0;
        event['first'] = 0
        setLazyState(event);
    }

    function onFilter(event: any) {
        event['page'] = 0;
        event['first'] = 0
        setLazyState(event);
    }

    let scrollHeight: any
    if (hiddenContentHeader && window.innerWidth > 767 && window.innerWidth < 1023) {
        scrollHeight = 'calc(100dvh - 146px)'
    }
    if (!hiddenContentHeader && window.innerWidth > 1080 && window.innerWidth < 1439) {
        scrollHeight = 'calc(100dvh - 213px)'
    }

    let wideTableFlag = (defectClassificator || actualMeasureResultsMark || !expandList)
    let measureResultsTableClassName = classNames({
        "w-100 h-100": wideTableFlag,
        "narrowTable": !wideTableFlag
    })

    return (
        <>
            <div className={measureResultsTableClassName}>
                {/* Отображение таблицы */}
                {loading
                    ?
                    <Loader />
                    :
                    <div className="card w-100">
                        <DataTable
                            value={tableValue}
                            scrollable
                            size="small"
                            removableSort
                            dataKey="id"
                            paginator={dataCount > 0}
                            rows={100}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="{first}-{last} из {totalRecords}"
                            filterDisplay="row"
                            emptyMessage="Данных нет"
                            scrollHeight={scrollHeight}
                            lazy
                            first={lazyState.first ?? 0}
                            totalRecords={dataCount}
                            headerColumnGroup={headerGroup}
                            onPage={onPage}
                            onSort={onSort}
                            sortField={lazyState.sortField}
                            sortOrder={lazyState.sortOrder}
                            onFilter={onFilter}
                            filters={lazyState.filters}
                            loading={loading}
                        >
                            {/* Столбцы таблицы */}
                            {columns?.map((item: any, idx: any) => (
                                <Column
                                    key={objectType + item.field}
                                    field={item.field}
                                    showFilterMenu={item.showFilterMenu}
                                    filter={item.canBeFiltered}
                                    filterElement={tableEnums[item.field] ? (options) => getOptionsRowFilterTemplate(options, item.filterPlaceholder, item.filterSelectValues) : undefined}
                                    filterPlaceholder={item.filterPlaceholder}
                                    sortable={item.canBeSorted}
                                    header={item?.imageSrc ? <img src={item?.imageSrc} /> : item.headerName}
                                    body={item.bodyImageSrc
                                        ? (rowData) => getMapLinkBody(rowData, item.bodyImageSrc, item.field)
                                        : (
                                            tableBooleanEnums[item.field] !== undefined
                                                ? (rowData) => getBooleanBody(rowData, item.field)
                                                : (rowData) => getMeasureResultsTableBasicBody(rowData, item.field, fieldsNoToWrap, type)
                                        )
                                    }
                                    align={item.bodyImageSrc ? "center" : tableBooleanEnums[item.field] !== undefined ? "center" : "right"}
                                    alignHeader="center"
                                    dataType={(item.valueType === "float" || item.valueType === "int" || item.valueType === "date") ? "numeric" : undefined}
                                    hidden={item.hidden}
                                    headerStyle={{ width: '100px' }}
                                />
                            ))}
                        </DataTable>
                    </div>
                }
            </div>
        </>

    );
}